import CreditTableScreens from "@repo/core/screens/CreditTable";

export const CreditTableHome = () => {
  return <CreditTableScreens.Search />;
};
